import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import messages from '../../locale/messages';
import TripsContainer from './TripsContainer';
import DashboardLayout from '../../components/Dashboard/DashboardLayout';

const title = 'Trips';

export default function action({ store, params, intl }) {

  const title = intl?.formatMessage(messages.trips);

  // From Redux Store
  const isAuthenticated = store.getState().runtime.isAuthenticated;
  const type = params.type;
  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  const hasPhoneNumber = store.getState().account.data?.phoneNumber
  let isSuperAdmin = store.getState().runtime.isSuperAdmin;

  if (!hasPhoneNumber && typeof window !== 'undefined' && !isSuperAdmin) {
    alert("Por favor agregue su número de teléfono")
    return { redirect: '/user/edit' };
  }

  return {
    title,
    component: <UserLayout hideMenu>
      <DashboardLayout>
        <TripsContainer userType="guest" type={type} />
      </DashboardLayout>
    </UserLayout>,
  };
}
